export function isTelegramWeb(userAgent = window.navigator.userAgent) {
    return userAgent.toLowerCase().includes('telegramweb')
}